const styles = theme => ({
  createOrganizationDialog: {
    zIndex: 1301
  },

  dialogPaper: {
    width: "100%",
    maxWidth: 800
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingTop: [theme.spacing(2), "!important"]
  },
  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: 0,
    margin: 0
  },

  logoContainer: {
    width: "133px",
    margin: theme.spacing(5)
  },
  contentContainer: {
    marginLeft: theme.spacing(8),
    marginRight: theme.spacing(8),
    marginBottom: theme.spacing(5)
  },
  labelTextColor: {
    color: theme.palette.primary.default
  },

  selectContainer: {
    marginBottom: theme.spacing(2)
  },
  selectPlanText: {
    color: theme.palette.primary.default,
    marginTop: -4
  },
  locationSuggestionContainer: {
    position: "absolute",
    marginTop: theme.spacing(-2),
    width: "100%",
    background: "#fff",
    boxShadow: `4px 3px 3px rgba(0, 0, 0, .3)`,
    zIndex: 5,
    maxWidth: 350
  },
  locationSuggestion: {
    padding: `${theme.spacing(1)}px`,
    borderBottom: `1px solid rgba(0, 0, 0, 0.2)`,
    "&:last-of-type": {
      borderBottom: "none"
    },
    cursor: "pointer"
  },
  locationSuggestionActive: {
    background: "#f1f1f1"
  },
  buttonsContainer: {
    paddingRight: theme.spacing(3),
    width: "100%",
    padding: `${theme.spacing(2)}px 0`
  },
  buttonCreate: {
    marginLeft: theme.spacing(2)
  },
  backContainer: {
    color: [theme.palette.primary.default, "!important"]
  },
  checkbox: {
    "&::hover": {
      background: ["transparent", "!important"]
    }
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/CreateOrganization/styles.js